module.exports = __webpack_public_path__ + "img/فانتزی.dbe0ba79.jpg";